import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "../../lib/lang";

export default function About() {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#0A0A0A] text-[#F5F2EB] section-py relative overflow-hidden"
    >
      <div className="container-x grid md:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="md:col-span-6 relative"
        >
          <div className="aspect-[4/5] overflow-hidden hover-zoom">
            <img
              src="/api/public-media/theo-oppolia/public/about/about-kitchen.webp"
              alt="Theo-Oppolia kitchen"
              width="800"
              height="1000"
              loading="lazy"
              decoding="async"
              className="hover-zoom-img w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 md:-right-12 w-1/2 aspect-square overflow-hidden hover-zoom hidden md:block border-4 border-[#0A0A0A]">
            <img
              src="/api/public-media/theo-oppolia/public/about/about-bedroom.webp"
              alt="Theo-Oppolia bedroom"
              width="600"
              height="600"
              loading="lazy"
              decoding="async"
              className="hover-zoom-img w-full h-full object-cover"
            />
          </div>
          <div className="absolute top-6 left-6 bg-[#B08858] text-white p-5 md:p-6">
            <p className="font-display text-3xl md:text-4xl leading-none">{t("about.no1")}</p>
            <p className="overline mt-1">{t("about.in_world")}</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="md:col-span-6"
        >
          <p className="overline text-[#B08858]">{t("about.overline")}</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05]">
            {t("about.title_1")}<br />
            <em className="text-[#B08858] not-italic">{t("about.title_em")}</em>
          </h2>
          <div className="mt-8 space-y-5 text-[#F5F2EB]/80 text-base md:text-lg leading-relaxed max-w-xl">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
            <p className="text-[#F5F2EB]/70 italic font-display text-xl md:text-2xl pt-3 border-l-2 border-[#B08858] pl-6">
              {t("about.quote")}
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/about" className="btn-sharp primary group" data-testid="about-cta-story">
              {t("common.read_story")}
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </Link>
            <Link to="/contact" className="btn-sharp outline-light" data-testid="about-cta-showroom">
              {t("common.find_showroom")}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
